module.exports = __webpack_public_path__ + "img/finished.e58b5cf7.png";